var React = require('react');

function LinkArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.9903 8.25144H2.24516","strokeWidth":"3","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M8 2L2.11765 8.25L8 14.5","strokeWidth":"3","strokeLinecap":"round","key":1})]);
}

LinkArrow.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16"};

module.exports = LinkArrow;

LinkArrow.default = LinkArrow;
